export default __webpack_public_path__ + "images/fe95b539ea5bdc22285b4551583495e8-blues_small.webp";